import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";
import { api, toEmbedUrl } from "@/lib/api";
import { Heart, QrCode } from "lucide-react";

export default function Welcome() {
  const [video, setVideo] = useState("");
  useEffect(() => { api.get("/settings").then((r) => setVideo(r.data.welcome_video_url || "")).catch(() => {}); }, []);

  const welcomeUrl = typeof window !== "undefined" ? `${window.location.origin}/welcome` : "";
  const embed = toEmbedUrl(video);

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-20 text-center" data-testid="welcome-page">
      <span className="gh-overline">A message for you</span>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#3A3632] mt-4">Welcome to Hope &amp; Favor</h1>
      <p className="font-hand text-3xl text-[#C4A4A4] mt-3">We are so grateful you are here.</p>
      <div className="gh-hairline my-8 max-w-[120px] mx-auto" />

      {embed ? (
        <div className="gh-frame overflow-hidden" data-testid="welcome-video">
          <div className="aspect-video bg-[#1A1A1A]">
            <iframe src={embed} title="Hope & Favor welcome video" className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        </div>
      ) : (
        <div className="bg-[#F2EFEB] border border-[#D9CBA0]/50 rounded-2xl p-14" data-testid="welcome-video-empty">
          <Heart className="h-10 w-10 text-[#C4A4A4] mx-auto" />
          <p className="text-[#6B655F] mt-4 max-w-md mx-auto">A short welcome video from our founder is on its way. In the meantime, know that this gift was sent because someone loves you and wanted you to feel seen.</p>
        </div>
      )}

      <p className="text-lg text-[#6B655F] mt-10 leading-relaxed max-w-2xl mx-auto font-light">
        Every Hope &amp; Favor box is created to remind you of one thing: you are seen, supported, and never alone. Whatever season you're walking through, we're holding you in our hearts.
      </p>
      <Link to="/shop" data-testid="welcome-shop" className="btn-primary mt-9 inline-flex">Discover our Care Boxes</Link>

      <div className="mt-16 border-t border-[#E5DFD5] pt-10">
        <div className="inline-flex items-center gap-2 gh-overline text-[10px]"><QrCode className="h-4 w-4" /> Card QR code</div>
        <p className="text-sm text-[#8A8175] mt-2 max-w-md mx-auto">This is the code printed on your Hope Card. Print or screenshot it — scanning always opens this welcome page.</p>
        <div className="bg-white inline-block p-4 rounded-xl border border-[#E5DFD5] mt-5" data-testid="welcome-qr">
          <QRCode value={welcomeUrl || "https://hopeandfavor.com/welcome"} size={148} fgColor="#3A3632" bgColor="#ffffff" />
        </div>
      </div>
    </div>
  );
}
